
import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import { Field } from 'formik';
import walkthroughIds from '../../../walkthroughIds';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import NumberField from 'components/forms/new/formikFormFields/NumberField';

const SBCaaSMaxChannelField = ({ darkMode, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <FormControl
      sx={{ margin: '0 !important' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Stack direction="row" spacing={stackSpacing} sx={stackStyling(true)}>
        <Box>
          <FormLabel sx={formLabelStyling(darkMode)}>
            Max Channel per SBC <span style={{ color: '#e53e3e' }}>*</span>
          </FormLabel>
          <Text sx={descriptionStyling} maxWidth={250}>
            Enter the maximum number of channels per SBC.
          </Text>
        </Box>
        <Box flex="1" minWidth="450px">
          <VStack width="100%" alignItems="normal" mt="15px">
            <Field name="maxChannel" validate={value => !value && 'Max Channel is required'}>
              {({ field, meta }) => (
                <>
                  <NumberField
                    field={field}
                    customWidth="100%"
                    inputProps={{
                      id: 'maxChannel',
                      'data-walkthroughid': walkthroughIds.serviceProfiles?.ufMaxChannelsInput,
                      ...props
                    }}
                  />
                  {meta.touched && meta.error && (
                    <Text color="red.500" fontSize="xs" mt={1} textAlign="right">
                      {meta.error}
                    </Text>
                  )}
                </>
              )}
            </Field>
          </VStack>
        </Box>
        {isHovered && (
          <FieldToolTip
            label="Enter the maximum number of channels per SBC."
            ariaLabel="sbcaas-max-channel-tip"
            left="25px"
            top="37px"
          />
        )}
      </Stack>
    </FormControl>
  );
};

export default SBCaaSMaxChannelField;
